import { render } from "./WebCatalogs.vue?vue&type=template&id=8f486164"
import script from "./WebCatalogs.vue?vue&type=script&lang=js"
export * from "./WebCatalogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/WebOrders/WebCatalogs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f486164"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f486164', __exports__)) {
    api.reload('8f486164', __exports__)
  }
  
  module.hot.accept("./WebCatalogs.vue?vue&type=template&id=8f486164", () => {
    api.rerender('8f486164', render)
  })

}


export default __exports__